export default {
  convertJsonToMessage: function(obj) {
    var result="";
    for(var prop in obj) {
      if(Object.prototype.hasOwnProperty.call(obj, prop)) {
        result+= prop +": "+obj[prop]+"\n";
      }
    }
    return result;
  },

  retrieveAsset: function(asset) {
    let baseUrl = '';
    if (process.env.NODE_ENV === 'development') {
      baseUrl = 'http://localhost:8080';
    }
    return baseUrl + asset;
  },
};
